<template>
  <div class="flex flex-dir-column app-layout orver-hidden-x" v-loading="queryLoading">
    <!-- 顶部搜索的表单 -->
    <div class="top-search padding-left-10 padding-right-10">
      <el-form
        align="left"
        size="small"
        ref="topForm"
        :model="formQuery"
        label-width="0"
        :inline="true"
        class="flex flex-wrap"
      >
        <el-form-item label="平台应用" label-width="70px">
          <system-select
            size="mini"
          />
        </el-form-item>
        <el-form-item label="" label-width="0">
          <div class="flex">
            <Version
                :os.sync="formQuery.os"
                :osVersion.sync="formQuery.osVersion"
                @update="queryActiveUserCount"
                noShowVersionList
                isMergeVersion
              />
            <el-checkbox class="margin-left-20" v-model="isCheckOrganization">
              <el-button
                style="position: relative; top: -3px;"
                size="mini"
                @click.prevent="Object.assign(dialog, {
                  visible: true
                })"
              >
                按组织架构筛选
                <el-tag
                  size="mini"
                  type="info"
                  v-if="formQuery.organizationId.length">
                  +{{ formQuery.organizationId.length }}
                </el-tag>
              </el-button>
            </el-checkbox>
          </div>
        </el-form-item>
        <el-form-item
          v-if="['iOS', 'Android', ''].includes(formQuery.os)"
          label="应用版本号"
          label-width="90px"
        >
          <el-input
            size="mini"
            clearable
            v-model="formQuery.version"
            placeholder="请输入应用版本号"
            @change="queryActiveUserCount"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            size="mini"
            v-model="formQuery.range"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
            unlink-panels
            :clearable="false"
            @change="queryActiveUserCount"
          ></el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <el-card
      class="flex-1 box-card box-card-echart padding-top-10"
      shadow="never"
    >
      <!-- 顶部各种总数据，还未传参 -->
      <el-card class="box-card">
        <div class="box-chart padding-top-20">
          <div class="title">活跃用户</div>
          <Echart
            :height="350"
            isMountedRender
            :id="'chartTime'"
            :data="chartTimeData"
            :islinePlie="true"
          />
        </div>
      </el-card>
      <div class="event-table flex-1 flex flex-column">
        <el-table
          max-height="350px"
          :data="tableData"
          v-loading="queryLoading"
          size="mini"
          stripe
        >
          <el-table-column
            v-for="(item, index) in columnsList"
            :width="item.width"
            :min-width="item.minWidth"
            :label="item.label"
            :prop="item.prop"
            :key="index"
            :fixed="item.fixed"
            :sortable="item.sortable"
          />
        </el-table>
        <!-- <el-row class="padding-20">
          <el-col align="right">
            <el-pagination
              class="analyze-users-pagination"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="tableQuery.pageNum"
              :page-sizes="[20, 50, 100, 200, 300, 400]"
              :page-size="tableQuery.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="tableQuery.total"
            ></el-pagination>
          </el-col>
        </el-row> -->
      </div>
    </el-card>
    <DialogOrganization :visible.sync="dialog.visible" @update="handleUpdateOrganizationIds"/>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Moment from 'moment';
import { queryActiveUserCount } from '@/api/analyze';
import Echart from '@/views/components/echart/index.vue';
// import OrganizationCascader from '@/views/components/organization-cascader/index.vue';
import DialogOrganization from './components/dialog-organization.vue';
import Version from '../components/version.vue';

export default {
  components: { Echart, DialogOrganization, Version },
  computed: {
    ...mapGetters('app', ['env', 'source', 'bizChannel']),
  },
  data() {
    return {
      isCheckOrganization: false,
      dialog: {
        visible: false,
      },
      chartTimeData: {
        x: [0],
        y: [{ name: '活跃用户', data: [0] }],
      },
      formQuery: {
        organizationId: [],
        range: [],
        osVersion: '',
        eventCode: '',
        os: '',
        version: '',
      },
      tableQuery: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
      queryLoading: false,
      tableData: [],
      columnsList: [
        {
          label: '日期',
          prop: 'analyzeTime',
        },
        {
          label: '活跃用户',
          prop: 'activeUser',
        },
        {
          label: '过去7天活跃用户',
          prop: 'day7ActiveUser',
        },
        {
          label: '过去30天活跃用户',
          prop: 'day30ActiveUser',
        },
      ],
    };
  },
  mounted() {
    const today = Moment().format('YYYY-MM-DD');
    const today2 = Moment().subtract(7, 'days').format('YYYY-MM-DD');
    this.formQuery.range = [new Date(today2), new Date(today)];
    this.queryActiveUserCount();
  },
  watch: {
    isCheckOrganization: {
      handler(val) {
        if (val && !this.formQuery.organizationId.length) {
          this.dialog.visible = true;
        } else if ((val && this.formQuery.organizationId.length) || !val) {
          // 选中，且有长度，查询
          // 取消, 查询
          this.queryActiveUserCount();
        }
      },
    },
    source: {
      handler() {
        this.queryActiveUserCount();
      },
    },
    bizChannel: {
      handler(val, old) {
        if (val !== old && this.source === '') {
          this.queryActiveUserCount();
        }
      },
    },
  },
  methods: {
    handleUpdateOrganizationIds(value) {
      this.formQuery.organizationId.splice(0);
      this.formQuery.organizationId.push(...value);

      // if (this.isCheckOrganization) {
      this.isCheckOrganization = !!value.length;
      this.queryActiveUserCount();
      // }
    },
    resetChartData(data = []) {
      const { range } = this.formQuery;
      const analyzeTimeTo = Moment(range[1]).format('YYYY-MM-DD');
      const analyzeTimeFrom = Moment(range[0]).format('YYYY-MM-DD');
      // eslint-disable-next-line operator-linebreak
      const days =
        Moment(analyzeTimeTo).diff(Moment(analyzeTimeFrom), 'days') + 1;

      const xList = [];
      const yList = [{ name: '活跃用户', data: [] }];
      // 计算相差多少天
      for (let i = 0, len = days; i < len; i++) {
        const time = Moment(analyzeTimeFrom).add(i, 'days').format('YYYY-MM-DD');
        console.log(time);
        xList.push(time);
        if (data.length) {
          // 根据时间节点，搜索出对应数据
          let user = 0;
          data.some(({ analyzeTime, activeUser }) => {
            if (analyzeTime.indexOf(time) !== -1) {
              console.log(time, activeUser);
              user = activeUser;
              return true;
            }
            return false;
          });

          yList[0].data.push(user || 0);
        } else {
          yList[0].data.push('暂无数据');
        }
        // yList[i].data.push(0);
      }

      console.log(xList);
      console.log(yList);
      this.chartTimeData.x.splice(0, this.chartTimeData.x.length, ...xList);
      this.chartTimeData.y.splice(0, this.chartTimeData.y.length, ...yList);
    },
    async queryActiveUserCount() {
      this.queryLoading = true;
      try {
        const { isCheckOrganization } = this;
        const {
          range,
          organizationId,
          osVersion,
          version,
          os,
        } = this.formQuery;
        const analyzeTimeTo = `${Moment(range[1]).format('YYYY-MM-DD')} 23:59:59`;
        const analyzeTimeFrom = `${Moment(range[0]).format('YYYY-MM-DD')} 00:00:00`;

        const params = {
          analyzeTimeTo,
          analyzeTimeFrom,
          osVersion,
          os,
        };

        params.version = ['iOS', 'Android', ''].includes(os) ? version : '';
        params.organizationIdList = isCheckOrganization ? organizationId : [];
        const {
          data,
        } = await queryActiveUserCount(params);

        this.resetChartData(data);
        this.tableData.splice(0, this.tableData.length, ...data);
        // chartData: {
        //   x: [1, 2, 3, 4, 5, 6],
        //   y: [{ name: '测试1', data: [2, 3, 4, 5, 6] },
        //     { name: '测试2', data: [4, 2, 1, 9, 10] },],
        // },
      } catch (error) {
        this.resetChartData();
        console.error(error);
      } finally {
        this.queryLoading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.box-card {
  border: 0;
  text-align: left;
  margin-bottom: 20px;
  &::v-deep {
    .el-card__body {
      padding-top: 0;
    }
  }
  &-echart {
    background: transparent;
    // max-height: 400px;
    overflow: auto;
  }
}
.app-layout {
  height: calc(100vh - 90px);
  min-width: 800px;
  margin: 15px 0 0;
  &::v-deep {
    .el-form-item {
      margin-bottom: 0;
    }
  }
}
// .top-search {
//   position: fixed;
//   top: 95px;
//   left: 15px;
//   right: 15px;
//   padding: 30px 20px 0;
//   background: #fff;
//   z-index: 99;
//   text-align: left;
//   border-radius: 5px;
// }
.box-chart {
  .title {
    font-size: 15px;
    font-weight: bold;
    margin-bottom: 10px;
  }
}
</style>
